@if (isLoading === true) {
  <ion-img src="./../../../../assets/Hubgrade_Loading_Animation.gif" class="general-loading-animation"
  ></ion-img>
}
@if (courses.length === 0) {
  <ion-card>
    <div class="stretcher-div"></div>
    <ion-card-content class="error-text">
      @if (hasSearched === true) {
        Es konnten leider keine Kurse ermittelt werden.
      }
      @if (searchFailed === true) {
        Bei der Suche ist etwas schiefgelaufen. Bitte überprüfe die
        eingegebenen Werte oder versuche es später
        erneut.
      }
    </ion-card-content>
  </ion-card>
}
<!--<button class="fav-button" (click)="toggleCourseFavoriteButtonClicked(courseTemplates[0].id)"-->
<!--            [disabled]="isLikingDisabled(courseTemplates[0].id)">-->
<!--  @if (courseHelper.isFavoriteCourse(courseTemplates[0].id, selectedCourseTemplateIds) === false) {-->
<!--    <i-->
<!--      class="button-icon icon-bookmark-2-outline icon-color-white" aria-label="lesezeichen setzen"></i>-->
<!--  }-->
<!--  @if (courseHelper.isFavoriteCourse(courseTemplates[0].id, selectedCourseTemplateIds) === true) {-->
<!--    <i-->
<!--      class="button-icon icon-bookmark-2 icon-color-white" aria-label="lesezeichen entfernen"></i>-->
<!--  }-->
<!--</button>-->
@for (courseTemplateItem of courseTemplates; track courseTemplateItem.id) {
  <ion-card
    >
    <div class="stretcher-div"></div>
    <ion-row>
      <ion-col size="10">
        <ion-card-header>
          <h4>{{ courseTemplateItem.name }}</h4>
        </ion-card-header>
      </ion-col>
      <ion-col class="margin-padding-0" size="2">
        <div class="ion-text-end">
          @if (isLoggedIn === true) {
            <ion-button class="fav-button" (click)="toggleCourseFavoriteButtonClicked(courseTemplateItem.id)"
                        [disabled]="isLikingDisabled(courseTemplateItem.id)">
              @if (courseHelper.isFavoriteCourse(courseTemplateItem.id, selectedCourseTemplateIds) === false) {
                <i
                  class="button-icon icon-bookmark-2-outline icon-color-white" aria-label="lesezeichen setzen"></i>
              }
              @if (courseHelper.isFavoriteCourse(courseTemplateItem.id, selectedCourseTemplateIds) === true) {
                <i
                  class="button-icon icon-bookmark-2 icon-color-white" aria-label="lesezeichen entfernen"></i>
              }
            </ion-button>
          }
          @if (isLoggedIn === false) {
            <ion-button class="fav-button" (click)="openLoginSuggestionModal()">
                <i
                  class="button-icon icon-bookmark-2-outline icon-color-white" aria-label="lesezeichen setzen"></i>
            </ion-button>
          }
        </div>
      </ion-col>
    </ion-row>
    <app-four-star-rating [courseTemplate]="courseTemplateItem"
    [userCourseRegistrations]="userCourseRegistrations" [user]="user"></app-four-star-rating>
    @for (courseItem of courseTemplateItem.courses; track courseItem.id) {
      <ion-row>
        <ion-col>
          <app-course-information [course]="courseItem" [userCourseRegistrations]="userCourseRegistrations" [user]="user"
            [isLoading]="isLoading" (isLoggedInEvent)="isLoggedIn"
            (registerForTemplateEvent)="setTemplateToCannotRegister($event)">
          </app-course-information>
        </ion-col>
      </ion-row>
    }
  </ion-card>
}
